export const apiUrl = "https://tabliczka.magusz.net/api/v1/";
